/* Il vocabolario del dominio, preso dal prototipo (§«Il modello in cinque parole»).
   I nomi sono in italiano perché sono le parole che usa il reparto: tradurli
   introdurrebbe un secondo glossario da tenere allineato. */
export function lineKey(ordine, riga) {
    return `${ordine}|${riga}`;
}
/** Chiave di un gruppo etichettato: `${cassetta}|${taglia}`. */
export function groupKey(cassetta, taglia) {
    return `${cassetta}|${taglia}`;
}
/** L'ordine imposto dalla regola aziendale: prima la stampa, poi il ricamo
    (regola 19, verbale 05/08). Le due stampe, DTF e DTG, vengono entrambe
    prima del ricamo; fra loro l'ordine è solo per leggere, non una regola. */
export const DECORATION_ORDER = ['DTF', 'DTG', 'WEMB'];
/**
 * Il reparto scritto in un indirizzo, con il ripiego su DTF.
 *
 * Il ripiego è deliberato: l'indirizzo arriva da un menu, non da un utente che
 * digita, e una coda vuota si legge meglio di una schermata rotta. Sta qui e
 * non nella rotta che lo usa perché è una decisione — quale reparto guardare —
 * e le decisioni si contano in un posto solo.
 */
export function departmentFromText(valore) {
    return DECORATION_ORDER.includes(valore) ? valore : 'DTF';
}
export function catalogFrom(righe) {
    const mappa = new Map();
    for (const r of righe)
        mappa.set(lineKey(r.ordine, r.id), r);
    return { riga: (o, r) => mappa.get(lineKey(o, r)) };
}
export const DEFAULT_CAPACITY = 24;
export const DEFAULT_BENCH_MAX = 20;
export function initialState(parziale = {}) {
    return {
        capienza: DEFAULT_CAPACITY,
        bancoMax: DEFAULT_BENCH_MAX,
        legami: {},
        righeAlBanco: {},
        fallati: {},
        ricevuti: {},
        etichette: {},
        confermate: {},
        consegne: {},
        congelati: {},
        fotografate: {},
        progressivoGruppo: 0,
        aperta: null,
        agganciato: null,
        arrivo: null,
        ...parziale,
    };
}
//# sourceMappingURL=types.js.map